export enum TicketProcessingReviewType {
  MANAGER = "Review",
  INPUT = "Open",
}

export enum TicketSubmitAction {
  APPROVED = "Approved",
  SUBMIT = "Submit",
  REVIEW = "Review",
}
